<template>
  <div id="home">
    <header>
      <v-parallax dark src="static/img/villa.jpg" height=600>
        <v-layout align-center column justify-end mb-5 flex lg6 offset-lg3>
          <h1 class="display-3 font-weight-black mb-3 text-uppercase"><a href="/">Pequeno Nido</a></h1>
          <h2 class="subheading text-uppercase">Moraira, Spain</h2>
          <v-btn icon dark @click.prevent="scrollToMain('main')" class="button-scroll">
            <v-icon x-large>arrow_downward</v-icon>
          </v-btn>
        </v-layout>
      </v-parallax>
    </header>
    <v-content id="main">
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <v-flex lg5 text-xs-center px-4>
            <h3 class="mt-5 mb-5">Pequeno Nido, our beautiful villa in Moraira, private pool, 5 mins from beach</h3>
            <v-gallery type="carousel" :images="list" class="mb-5" />
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer class="d-block">
      <v-parallax dark src="static/img/villa.jpg" height=600>
        <v-layout align-center column justify-end mb-5 flex lg6 offset-lg3 />
      </v-parallax>
      <v-container fluid>
        <v-layout justify-center align-center>
          <v-flex lg5 text-xs-center px-4 my-5>
            <h3 class="mb-5">Contact</h3>
            <address>
              Caroline Harris
              <br /><a href="mailto:info@pequeno-nido.com">info@pequeno-nido.com</a>
              <br />07764491307
            </address>
          </v-flex>
        </v-layout>
      </v-container>
    </v-footer>
  </div>
</template>

<script>

export default {
  data () {
    return {
      list: [
        { title: 'Bedroom', url: 'static/img/gallery/1.jpg' },
        { title: 'Living Room', url: 'static/img/gallery/2.jpg' },
        { title: 'Kitchen', url: 'static/img/gallery/3.jpg' },
        { title: 'Kitchen', url: 'static/img/gallery/4.jpg' }
      ]
    }
  },
  methods: {
    scrollToMain: function (elementId) {
      const element = document.querySelector(elementId)
      window.scrollTo({
        'behavior': 'smooth',
        'left': 0,
        'top': element.offsetTop
      })
    }
  }
}
</script>

<style lang="less" scoped>

header {
  .button-scroll {
    align-self: flex-end;
  }
}

</style>